import { render, staticRenderFns } from "./Block7.vue?vue&type=template&id=33f07420&scoped=true"
import script from "./Block7.vue?vue&type=script&lang=js"
export * from "./Block7.vue?vue&type=script&lang=js"
import style0 from "./Block7.vue?vue&type=style&index=0&id=33f07420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f07420",
  null
  
)

export default component.exports